<div class="dialog">
    <div class="dialog_header">
        <button mat-icon-button class="close" [disabled]="loading" (click)="openConfirmDialog(); cancelPop();"><svg
                xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                <path id="ic_close"
                    d="M213.746-744.393l-6.441,6.436a1.459,1.459,0,0,1-1.063.457,1.406,1.406,0,0,1-1.046-.457,1.418,1.418,0,0,1-.45-1.054,1.449,1.449,0,0,1,.45-1.037l6.441-6.452-6.441-6.452a1.419,1.419,0,0,1-.441-1.037,1.473,1.473,0,0,1,.441-1.053,1.406,1.406,0,0,1,1.046-.457,1.485,1.485,0,0,1,1.063.441l6.441,6.452,6.458-6.452a1.431,1.431,0,0,1,1.046-.441,1.458,1.458,0,0,1,1.063.457,1.443,1.443,0,0,1,.433,1.053,1.448,1.448,0,0,1-.45,1.037l-6.441,6.452,6.441,6.452a1.419,1.419,0,0,1,.441,1.037,1.473,1.473,0,0,1-.441,1.054,1.406,1.406,0,0,1-1.046.457,1.406,1.406,0,0,1-1.046-.457Z"
                    transform="translate(-204.746 755.5)" fill="#999" />
            </svg>
        </button>
        {{"ClaimPointOrOffer.Claim points or offer"|translate}}
    </div>
    <form [formGroup]="formGroup">
        <div [hidden]='dataLoading'>
            <div class="dialog_content p-0" mat-dialog-content>
                <div>
                     <!-- [hidden]="!action.isStart" -->
                    <div>
                        <div *ngIf='action.isLoading || scannerLoader' class="dataLoading py-5 my-5">
                            <mat-spinner class="m-auto" diameter="50"></mat-spinner>
                        </div>
                        <div class="scanner-box" [hidden]="action.isLoading || scannerLoader">
                            <ngx-scanner-qrcode #action="scanner" (event)="applyAction($event)"></ngx-scanner-qrcode>
                            <span class="text">
                                {{ 'ClaimPointOrOffer.Please scan the QR code for the offer or redeemed points' | translate }}
                            </span>
                            <button mat-icon-button class="btn-green-light create-item" type="button" *ngIf="CamerasListIds.length > 1" (click)="ToggelCamera()">
                                <mat-icon>switch_camera</mat-icon>
                            </button>
                        </div>
                    </div>
                    <div class="Qr-Code" *ngIf="!actionApplied">
                        <h6>{{ 'ClaimPointOrOffer.Or you can enter the code manually' | translate }}</h6>
                        <mat-form-field>
                            <input matInput formControlName="code"
                                [placeholder]="'ClaimPointOrOffer.Enter the code' | translate">
                                <mat-error *ngIf="hasError('code','required')">
                                    {{"form_message.Required"|translate}}
                                </mat-error>
                        </mat-form-field>
                    </div>
                    <div *ngIf="actionApplied">
                        <div class="qr-code-success">
                            <img src="./assets/images/icons/success.svg" alt="">
                            <h3 class="font-22 fontSemiBold text-color text-center mb-1">
                                {{ 'ClaimPointOrOffer.The QR code has been scanned successfully' | translate }}</h3>
                            <p class="font-14 fontRegular grey-color text-center mb-0">
                                {{ 'ClaimPointOrOffer.Please select the branch to complete the offer/points claimed process' | translate }}</p>
                        </div>
                    </div>

                    <div class="field-text-flex">
                        <span class="sub">{{ 'vendorAdminProfile.Branch' | translate }}</span>
                        <mat-form-field hideRequiredMarker>
                            <mat-label>{{"ClaimPointOrOffer.Select the branch" | translate}}</mat-label>
                            <mat-select formControlName="branch_id">
                                <mat-option *ngFor="let branch of data.branches"
                                    [value]="branch.id">{{branch.name}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="hasError('branch_id','required')">
                                {{"form_message.Required"|translate}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

            </div>
        </div>
        <div *ngIf='dataLoading' class="dataLoading">
            <mat-spinner class="m-auto" diameter="50"></mat-spinner>
        </div>
        <div class="dialog_actions" mat-dialog-actions>
            <button mat-button (click)="openConfirmDialog(); cancelPop()" type="button" [disabled]="loading"
                class="btn-secondary">{{"general.Cancel"|translate}}</button>
            <button mat-button class="btn-primary" [disabled]="loading" (click)="ClaimOfferOrPoint()"
                [class.loading]="loading">{{"ClaimPointOrOffer.Claim"|translate}}</button>
        </div>
    </form>
</div>
